/**
 * Data for geographical repartition map
 */
module.exports = [
  // P1
  [
    {id: "north-america", name_formated: "Amérique", value: 13.64},
    {id: "europe",        name_formated: "Europe",   value: 81.24},
    {id: "asia",          name_formated: "Asie",     value: 5.12}
  ],
  // P2
  [
    {id: "north-america", name_formated: "Amérique", value: 17.06},
    {id: "europe",        name_formated: "Europe",   value: 77.82},
    {id: "asia",          name_formated: "Asie",     value: 5.11}
  ],
  // P3
  [
    {id: "north-america", name_formated: "Amérique", value: 19.86},
    {id: "europe",        name_formated: "Europe",   value: 73.96},
    {id: "asia",          name_formated: "Asie",     value: 6.19}
  ],
  // P4
  [
    {id: "north-america", name_formated: "Amérique", value: 23.82},
    {id: "europe",        name_formated: "Europe",   value: 69.97},
    {id: "asia",          name_formated: "Asie",     value: 6.21}
  ],
  // P5
  [
    {id: "north-america", name_formated: "Amérique", value: 26.33},
    {id: "europe",        name_formated: "Europe",   value: 64.84},
    {id: "asia",          name_formated: "Asie",     value: 8.84}
  ],
  // P6
  [
    {id: "north-america", name_formated: "Amérique", value: 33.22},
    {id: "europe",        name_formated: "Europe",   value: 54.70},
    {id: "asia",          name_formated: "Asie",     value: 12.09}
  ],
  // P7
  [
    {id: "north-america", name_formated: "Amérique", value: 36.42},
    {id: "europe",        name_formated: "Europe",   value: 51.65},
    {id: "asia",          name_formated: "Asie",     value: 11.93}
  ],
  // P8
  [
    {id: "north-america", name_formated: "Amérique", value: 38.31},
    {id: "europe",        name_formated: "Europe",   value: 50.03},
    {id: "asia",          name_formated: "Asie",     value: 11.66}
  ],
  // P9
  [
    {id: "north-america", name_formated: "Amérique", value: 40.10},
    {id: "europe",        name_formated: "Europe",   value: 46.52},
    {id: "asia",          name_formated: "Asie",     value: 13.37}
  ],
  // P10
  [
    {id: "north-america", name_formated: "Amérique", value: 43.07},
    {id: "europe",        name_formated: "Europe",   value: 43.97},
    {id: "asia",          name_formated: "Asie",     value: 12.96}
  ]
];